import request from '@/utils/request'

export function getVerificationCode(param) {	
	return request.post('sms/getVerificationCode',param)
}

export function validVerificationCode(param) {	
	return request.post('sms/validVerificationCode',param)
}